<template>
<div class="SendMessage">

  <a-form-model :model="form" :rules="rules" ref="ModleForm">
    <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item
              label="消息标题"
              prop="title"
              :labelCol="{ span: 3, offset: 0 }"
              :wrapperCol="{ span: 17, offset: 0 }"
            >
              <a-textarea
                allowClear
                v-model="form.title"
                :maxLength="150"
                placeholder="请输入消息标题,150字内"
                :rows="2"
              />
<!--              <div class="textarea">限制输入字数：{{form.title.length}}/150</div>-->
            </a-form-model-item>
          </a-col>
      <a-col :span="24">
        <a-form-model-item
          label="消息内容"
          prop="content"
          :labelCol="{ span: 3, offset: 0 }"
          :wrapperCol="{ span: 17, offset: 0 }"
        >
          <a-textarea
            allowClear
            v-model="form.content"
            :maxLength="1000"
            placeholder="请输入消息内容,1000字内"
            :rows="3"
          />
          <span style="color: red;">发送短信请尽量精简内容在70字以内！</span>
          <div class="textarea">限制输入字数：{{form.content.length}}/1000</div>
        </a-form-model-item>
      </a-col>
          <a-col :span="24">
            <a-form-model-item
              prop="smsFlag"
              label="消息类型:"

              :labelCol="{ span: 3, offset: 0 }"
              :wrapperCol="{ span: 17, offset: 0 }">
              <a-radio-group v-model="form.smsFlag">
<!--                <a-checkbox :value="1">同时发送短信</a-checkbox>-->
                <a-radio :value="1"  >
                  站内通知
                </a-radio>
                <a-radio :value="2"  >
                  短信
                </a-radio>
                <a-radio :value="3"  >
                  站内通知及短信
                </a-radio>
              </a-radio-group>
<!--              </a-checkbox-group>-->
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item
              label="发送范围"
              prop="sendType"
              :labelCol="{ span: 3, offset: 0 }"
              :wrapperCol="{ span: 17, offset: 0 }"
            >
              <a-radio-group v-model="form.sendType">
                <a-radio v-for="iten in sendTypelist" :key="iten.status" :value="iten.status">
                  {{iten.title}}
                </a-radio>
              </a-radio-group>
<!--              <a-select-->
<!--                allowClear-->
<!--                v-model="form.sendType"-->
<!--                placeholder="发送范围"-->
<!--                @change="ChangeSend"-->
<!--              >-->
<!--                <a-select-option-->
<!--                  v-for="iten in sendTypelist"-->
<!--                  :key="iten.status"-->
<!--                  :value="iten.status"-->
<!--                >{{ iten.title }}</a-select-option>-->
<!--              </a-select>-->
            </a-form-model-item>
          </a-col>

          <a-col :span="24"  v-if="form.sendType == 3">
            <a-form-model-item
              label="请输入手机号"
              prop="mobiles"
              :labelCol="{ span: 3, offset: 0 }"
              :wrapperCol="{ span: 17, offset: 0 }"
            >
              <a-textarea
                allowClear
                v-model="form.mobiles"
                placeholder="请输入手机号"
                :rows="3"
              /> <br>
              <a-span>说明：手机号之间用","号隔开。</a-span>
            </a-form-model-item>
          </a-col>

      <a-col :span="24"  v-if="form.sendType == 4">
        <a-form-model-item
          label="请选择角色"
          prop="roleId"
          :labelCol="{ span: 3, offset: 0 }"
          :wrapperCol="{ span: 17, offset: 0 }"
        >
          <a-select
            allowClear
            v-model="form.roleIds"
            mode="multiple"
            placeholder="选择角色"
          >
            <a-select-option
              v-for="iten in rolelist"
              :key="iten.id"
              :value="iten.id"
            >{{ iten.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
      </a-col>
      </a-row>
  </a-form-model>

  <search-no-button-form
    v-if="form.sendType == 1  "
    :chgDataList="SearchDataList"
    :table-btn-arr="tableBtnArr"
    @handleEvent="btnGroupEvents"
    @handle-search="getReportDataPreviewData2"
    ref="searchForm"
    style="margin-left: 40px"
  >
  </search-no-button-form>


            <search-form
              v-if=" form.sendType == 2"
              :chgDataList="SearchDataList"
              :table-btn-arr="tableBtnArr"
              @handleEvent="btnGroupEvents"
              @handle-search="getReportDataPreviewData2"
              ref="searchForm"
              style="margin-left: 40px"
            >
            </search-form>





<a-form-model>
  <a-row>

    <a-col :span="14"   v-if="  form.sendType == 2">
      <a-form-model-item
        :labelCol="{ span: 1, offset: 0 }"
        :wrapperCol="{ span: 23, offset: 0 }"
        label=" "
        :colon="false"
      >
        <use-table
          :current="page"
          :data="data"
          :tableHeaderModel="tableHeaderModel"
          @rowEvent="rowEvents"
          :totals="total"
          ref="useTable"
          @pagination-event="paginationEvent"

        />
    </a-form-model-item>
    </a-col>
    <a-col :span="2"   v-if="  form.sendType == 2">
      <a-button
        :style="{ marginLeft: '8px' }"
        type="primary"
        @click="handleSelect"
      > >></a-button
      >
    </a-col>
    <a-col :span="8"   v-if="  form.sendType == 2">
      <a-select
        mode="multiple"
        v-model="form.selUsers"
        autoclear
        placeholder="请选择待发送的人员"
        id="selUsers"
        @change="selChange"
      >
        <a-select-option
          v-for="iten in userList"
          :key="iten.id"
          :value="iten.id"
        >{{ iten.orgName }}-{{ iten.name }}</a-select-option
        >
      </a-select>


    </a-col>
  </a-row>
  </a-form-model>


</div>
</template>
<script>
import UseTable from "./UseTable";
import province from "@/utils/province.js";
import SearchForm from "@/components/SearchForm.vue";
import SearchNoButtonForm  from "@/components/SearchNoButtonForm.vue";
import {queryRole} from "../../../config/typeConfig";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
// import SearchNoButtonForm from "../../SearchNoButtonForm";

export default {
  name: "SendMessage",
  data() {
    return {
      rules:{
        title: [
          {
            required: true,
            message: "请输入消息标题",
            trigger: "blur"
          }
        ],
        content: [
          {
            required: true,
            message: "请输入消息内容",
            trigger: "blur"
          }
        ],
       smsFlag: [
         {
           required: true,
           message: "请选择消息类型",
           trigger: "blur"
         }
       ],
        sendType:[
          {
            required: true,
            message: "请选择发送范围",
            trigger: ["change","blur" ]
          }
        ],
      },
      rules2:{

      },
      sendTypelist:[

      ],
      provinceList: [],
      cityList: [],
      countyList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      isJSZG: false,
      data:[],
      tableBtnArr:[],
      userList:[],
      selectUsers:[],
      SearchDataList: [
        {
          key: "province",
          title: "省份",
          type: "select",
          params: {},
          selectName: "getProvinceBasic",
          placeholder: "所在省",
          childrenKey: "city",
          isAuth: "Search:Select:province"
        },
        {
          key: "city",
          title: "市",
          type: "select",
          params: {},
          selectName: "getCityBasic",
          placeholder: "所在市",
          childrenKey: "county",
          isAuth: "Search:Select:city"
        },
        {
          key: "county",
          title: "县",
          type: "select",
          params: {},
          selectName: "getcountyBasic",
          placeholder: "所在县",
          childrenKey: "",
          isAuth: "Search:Select:county"
        }
      ],
      tableHeaderModel:[
        {
          dataIndex: "orgName",
          title: "所在单位"
        },

        {
          dataIndex: "name",
          title: "姓名"
        },
        {
          dataIndex: "phone",
          title: "手机号"
        },
      ],
      formData:{
        province: undefined,
        city: undefined,
        county: undefined,
      },
      form: {
        sendType:1,
        content:'',
        smsFlag: 1,
        selUsers:[],
        mobiles:''
      },
      rolelist:[]
    };
  },
  components: {
    UseTable,
    SearchForm,
    SearchNoButtonForm
  },
  mounted() {
    // this.fetchData();
    this.getRoleData();
    this.getRoleData();
    let userInfoStr = sessionStorage.getItem("unInfo");
    userInfoStr = userInfoStr == null ? "" : userInfoStr;
    const userInfo = JSON.parse(userInfoStr);
    const orgType=userInfo.user.orgType;
    const provinceMgr = userInfo.user.manage
    if(orgType == 5){
      this.isJSZG = true;
      this.fetchData();
      this.sendTypelist=[
        {
          status:1,
          title:'按照省份发送'
        },
        {
          status:2,
          title:'按照人员选择'
        },
        {
          status:3,
          title:'录入系统外手机号'
        },
        {
          status:4,
          title:'按照角色发送'
        },
      ];
    }else if(orgType == 4 && provinceMgr == 1){
      this.isJSZG = false;
      // this.fetchData();
      this.sendTypelist=[

        {
          status:2,
          title:'按照人员选择'
        },
        {
          status:4,
          title:'按照角色发送'
        },
      ];
      console.log("sendTypelist="+this.sendTypelist);
    }else{
      this.isJSZG = false;
      this.fetchData();
      this.sendTypelist=[
        {
          status:2,
          title:'按照人员选择'
        },

      ];
    }
  },
  computed: {
    ...mapState(["tableSelected", "tableSelectArr"])
  },
  methods:{
    handleSearch(){
      this.getReportDataPreviewData2()
    },
    handleReset(){
      const refs = this.$refs.queryForm;
      refs.resetFields();
      this.getReportDataPreviewData2()
    },



    ChangeSend(val){
      console.log(val)
    },

    // 表格操作按钮组事件
    btnGroupEvents(methodName) {
      this[methodName]();
    },

    getRoleData(){
      queryRole(this,{}).then((data)=>{
        if(data){
          this.rolelist = data;
        }
      })
    },

    getReportDataPreviewData2(formData = this.formData,page = 1) {
      this.page = page;
      this.formData = formData;

      let params = {
        urlName: "queryUser",
        params: {
          pageNo: this.page,
          pageSize: this.pageSize
        }
      };
      this.formData.pageNo = this.page;
      this.formData.pageSize = this.pageSize;
      params.params = this.formData;
      this.getTableData(params.params);
    },
    // 表格行操作按钮组事件
    rowEvents(obj) {
      this[obj.method](obj.row, obj.num);


    },

    getTableData(params = this.formData) {
      const uri = "queryUserByMessage";
      this.$json(uri, params).then(response => {
          let data = response.record;
          this.total = response.total;
          this.data = data;
        }).catch(e => {
          this.$message.error(e.message);
        });
    },
    getSelectRows(selectRows){
      this.selectUsers = selectRows;


    },
    selChange(selectedOptions){
      console.log("selectedOptions="+selectedOptions);
      this.form.selUsers = selectedOptions;
    },
    handleSelect(){
        // this.userList.push();
     this.$refs.useTable.tableSelectArr.map(item => {
       console.log("ITEM="+item);
       this.data.map(ditem=>{
         if(ditem.id == item){
           if(!this.userList.includes(ditem)){
             if( this.userList.length >0) {
               this.userList.push(ditem);

              this.form.selUsers.push(ditem.id);

             }else{
               this.userList= [ditem];
              this.form.selUsers =  [ditem.id];

             }
           }
         }
       })


          });
    },
    fetchData() {
      province.getProvinceBasic(this).then(res => {
        this.provinceList = res;
      });
      this.getReportDataPreviewData2();
    },
    // 分页事件
    paginationEvent(arr) {
      // const aa="";
      this.page = arr.page;
      this.pageSize = arr.pageSize;
      this.getReportDataPreviewData2(this.formData,arr.page);

      this.$refs.useTable.selectRows=[];
    },
    provinceHandleChange(val) {
      this.formData.city = undefined;
      this.formData.county = undefined;
      if (this.formData.province != undefined) {
        this.queryArea(val, "city");
      }
    },
    cityHandleChange(val) {
      this.form.county = undefined;
      if (this.form.city != undefined) {
        this.queryArea(val, "county");
      }
    },
    countyHandleChange(val) {},
    queryArea(parentId, type) {
      let orgType = 4;
      if ("city" == type) {
        orgType = 3;
      } else if ("county" == type) {
        orgType = 2;
      }
      const query = {
        url: "queryBaseOrgBasic",
        params: {
          parentId: parentId,
          orgType: orgType
        }
      };
      this.$json(query.url, query.params).then(res => {
        const data = res.record;
        if ("city" == type) {
          this.cityList = data;
        } else if ("county" == type) {
          this.countyList = data;
        }
      });
    },
  }
}
</script>

<style scoped>

.textarea{
  font-size: 12px;
  text-align: right;
  margin-top: -15px;
  margin-right: 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/layout/header/SendMessage.vue